






























import { Component, Mixins } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import { getModule } from 'vuex-module-decorators';
import { StatsStore } from '@/store/stats-store';
import { LoadingStore } from '@/store/loading-store';
import Highcharts from 'highcharts';
import { countsToGraphData, getMonochromeColors } from '@/charts/chart-utils';
import { OrgsStore } from '@/store/orgs-store';
import { AuthStore } from '@/store/auth-store';
import store from '@/store';

const loadingState = getModule(LoadingStore);
const statsState = getModule(StatsStore);
const orgsState = getModule(OrgsStore);
const authState = getModule(AuthStore, store);

@Component({
    components: { }
})
export default class SemiCircleDonutChartExample extends Mixins(LocaleMixin) {
    private org = authState.userInfoObject!.org_id;
    private chartOptions: Highcharts.Options = {
        chart: {
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: 'Statuses'/* ,
            align: 'center', // horizontal alignment
            verticalAlign: 'middle', // vertical alignment
            y: 20, // vertial offset
            x: 10 // horizontal offset */
        },
        subtitle: {
            text: 'Breakdown of current opportunity statuses'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        tooltip: {
            pointFormat: '{point.percentage:.0f} %<br>Count: {point.y}'
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                colors: getMonochromeColors('#0060AF'),
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    distance: 5 // how far the label appear from the chart
                },
                startAngle: -90, // on a clock, -90 is 9 o'clock
                endAngle: 90, // // on a clock, 90 is 3 o'clock
                center: ['50%', '50%'] // where the center of the chart is
                // size: '100%' // manually set size of graph
            }
        },
        series: [
            {
                name: 'Status',
                type: 'pie',
                innerSize: '50%', // controls the size of the donut "hole"
                data: []
            } as Highcharts.SeriesPieOptions
        ]
    };

    get orgs() {
        return orgsState.stored;
    }

    async created() {
        await this.prepStatusCounts();
    }

    async prepStatusCounts() {
        loadingState.loadingIncrement('semiCircleDonutChart');
        await orgsState.init();
        await statsState.initStatusCounts({ orgIds: [this.org] });
        this.updateChart();
        loadingState.loadingDecrement('semiCircleDonutChart');
    }

    async updateStatusCounts() {
        loadingState.loadingIncrement('semiCircleDonutChart');
        await statsState.retrieveStatusCounts({ orgIds: [this.org] });
        this.updateChart();
        loadingState.loadingDecrement('semiCircleDonutChart');
    }

    private updateChart() {
        const orgName = this.orgs.find(org => org.id === this.org)!.name;
        this.chartOptions.title!.text = 'Statuses - ' + orgName;
        (this.chartOptions.series![0] as Highcharts.SeriesPieOptions).data = countsToGraphData(statsState.statusCounts);
    }
};
